import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    console.log('Connected controller');
  }

  smoothNavigate() {
    // static targets to grab the element was not working properly, so I decided to use vanilla JS
    let freightComponent = document.querySelector('[data-marketplace-announcement-target]');
    freightComponent?.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
}
